import { applyMiddleware, createStore, AnyAction } from 'redux';
import thunkMiddleware, { ThunkDispatch } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './reducers';

export default function configureStore(preloadedState?: any) {
  const middlewares = [thunkMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const composedEnhancers = composeWithDevTools(middlewareEnhancer);

  return createStore(rootReducer, preloadedState, composedEnhancers);
}

// ✅ Тип корневого состояния
export type RootState = ReturnType<typeof rootReducer>;

// ✅ Тип dispatch с поддержкой thunk
export type AppDispatch = ThunkDispatch<RootState, any, AnyAction>;
